<!-- 会议设置 -->
<template>
  <div class="meetingSetting-wrap">
    <p class="title">
      会议设置
    </p>
    <div class="list" :class="{ join: props.settingType == 'join' }">
      <div class="handle-list" v-if="props.settingType == 'join'">
        <div class="handle-item">
          <label for="camera">摄像头</label>
          <select name="" id="camera">
            <option value="0">关闭</option>
            <option value="1">开启</option>
          </select>
        </div>
        <div class="handle-item">
          <label for="micro">麦克风</label>
          <select name="" id="micro">
            <option value="0">关闭</option>
            <option value="1">开启</option>
          </select>
        </div>
        <div class="handle-item">
          <label for="output">音频输出</label>
          <select name="" id="output">
            <option value="0">默认</option>
            <option value="1">开启</option>
          </select>
        </div>
      </div>
      <div class="item" :class="{ active: state.setting.indexOf(index) > -1 }" v-for="(item, index) in settingList"
        :key="index" @click="chooseSetting(index)">
        <span class="cir"></span>
        <span class="txt">{{ item }}</span>
        <Transition name="fade">
          <div class="meeting-password" v-if="index == 0" v-show="state.setting.indexOf(0) > -1" @click.stop="() => { }">
            <input :type="inputType" name="meetingPassword" id="meetingPassword" placeholder="请设置6位密码">
            <img src="../../assets/img/icons/icon-eye.png" alt="" class="eye" @click="toggleShowPassword"
              v-show="inputType == 'password'">
            <img src="../../assets/img/icons/icon-eye-on.png" alt="" class="eye" @click="toggleShowPassword"
              v-show="inputType == 'text'">
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue';

const props = defineProps({
  settingType: String
})

// TODO
const settingList = computed(() => {
  const arr = [
    "入会密码",
    "每次入会前显示音频设置",
    "入会时开启摄像头",
    "入会时全员静音",
    "允许成员在创建人进入会议前加入会议",
    "自动云录制",
    "退出会议时需要确认"
  ]
  if (props.settingType == "join") {
    arr.splice(3, 2);
    arr.splice(3, 1);
  }
  return arr;
})

const inputType = ref("password");

const state = reactive({
  setting: []
})

function chooseSetting(index) {
  const settingIndex = state.setting.indexOf(index);
  settingIndex > -1 ? state.setting.splice(settingIndex, 1) : state.setting.push(index);
}

function toggleShowPassword() {
  inputType.value == "password" ? inputType.value = "text" : inputType.value = "password";
}
</script>

<style scoped>
.meetingSetting-wrap {
  width: 30.20833vw;
  margin: 0 auto;
}

.meetingSetting-wrap .title {
  font-size: 0.9375vw;
  line-height: 1.30208vw;
  font-weight: bold;
  color: #2F3367;
  margin-bottom: 0.41666vw;
}

.meetingSetting-wrap .list.join {
  width: 28.125vw;
  margin-left: auto;
}

.meetingSetting-wrap .list .item {
  cursor: pointer;
  margin-bottom: 0.83333vw;
}

.meetingSetting-wrap .list .item:last-child {
  margin-bottom: 0;
}

.meetingSetting-wrap .list .item .meeting-password {
  position: relative;
  width: 28.125vw;
  margin-left: auto;
  margin-top: 0.41666vw;
}

.meetingSetting-wrap .list .item .meeting-password input {
  display: block;
  width: 26.24166vw;
  box-sizing: border-box;
  font-size: 0.83333vw;
  line-height: 1;
  color: #171A41;
  padding: 0.625vw 1.25vw;
  border: 0.05208vw solid #D4D6D8;
  border-radius: 0.20833vw;
  margin-left: auto;
}

.meetingSetting-wrap .list .item .meeting-password .eye {
  position: absolute;
  top: 50%;
  right: 0.83333vw;
  transform: translateY(-50%);
  display: block;
  width: 1.25vw;
  cursor: pointer;
  z-index: 10;
}

.meetingSetting-wrap .list .item .meeting-password input::placeholder {
  color: #D4D6D8;
}

.meetingSetting-wrap .list .item .cir {
  display: inline-block;
  width: 1.04166vw;
  height: 1.04166vw;
  box-sizing: border-box;
  border-radius: 0.3125vw;
  border: 0.05208vw solid #D4D6D8;
  vertical-align: middle;
  margin-right: 0.83333vw;
}

.meetingSetting-wrap .list .item .txt {
  display: inline-block;
  font-size: 0.83333vw;
  line-height: 1;
  color: #171A41;
  vertical-align: middle;
}

.meetingSetting-wrap .list .item.active .cir {
  background-image: url("../../assets/img/icons/icon-radio-check.png");
  background-repeat: no-repeat;
  background-size: 0.52083vw 0.52083vw;
  background-position: center center;
  background-color: #B41D22;
  border: none;
}

.fade-enter-active {
  transition: all 0.2s ease-in;
}

.fade-leave-active {
  transition: all 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.handle-list {
  margin-bottom: 1.25vw;
}

.handle-list .handle-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1.25vw;
}

.handle-list .handle-item:last-child {
  margin-bottom: 0;
}

.handle-list .handle-item label {
  min-width: 3.33333vw;
  font-size: 0.83333vw;
  line-height: 1;
  color: #8B8FA8;
  margin-right: 0.83333vw;
  flex-shrink: 0;
}

.handle-list .handle-item select {
  display: block;
  font-size: 0.83333vw;
  line-height: 1.25vw;
  color: #171A41;
  padding: 0.625vw 1.25vw;
  border-radius: 0.20833vw;
  background-color: transparent;
  border: 0.05208vw solid #D4D6D8;
  background-image: url("../../assets/img/icons/icon-arr-down.png");
  background-repeat: no-repeat;
  background-size: 1.14583vw auto;
  background-position: right 1.25vw center;
  flex: 1;
}

@media screen and (max-width: 750px) {

  .meetingSetting-wrap {
    width: 82.93333vw;
  }

  .meetingSetting-wrap .title {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.6vw;
  }

  .meetingSetting-wrap .list .item {
    margin-bottom: 3.2vw;
  }

  .meetingSetting-wrap .list .item .meeting-password {
    width: 76.53333vw;
    margin-top: 1.6vw;
  }

  .meetingSetting-wrap .list .item .meeting-password input {
    width: 76.53333vw;
    font-size: 3.73333vw;
    padding: 2.66666vw 3.2vw;
    border-radius: 0.53333vw;
    border-width: 0.13333vw;
  }

  .meetingSetting-wrap .list .item .meeting-password .eye {
    right: 3.2vw;
    width: 4.26666vw;
  }

  .meetingSetting-wrap .list .item .cir {
    width: 4.26666vw;
    height: 4.26666vw;
    border-radius: 0.8vw;
    margin-right: 2.13333vw;
  }

  .meetingSetting-wrap .list .item .txt {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
  }

  .meetingSetting-wrap .list .item.active .cir {
    background-size: 60%;
  }

  .meetingSetting-wrap .list.join {
    width: 100%;
  }

  .handle-list .handle-item label {
    min-width: 14.93333vw;
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-right: 2.13333vw;
  }

  .handle-list .handle-item select {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    padding: 2.66666vw 3.2vw;
    background-size: 4.26666vw auto;
    border-radius: 0.53333vw;
    border-width: 0.13333vw;
  }

  .handle-list .handle-item {
    margin-bottom: 4.26666vw;
  }

  .handle-list {
    margin-bottom: 4.26666vw;
  }

}
</style>